import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { CardActions, Modal } from '@material-ui/core';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import {
  getSettingMenuFree,
  getGochiMenuDetail,
  removeGochiKidMenu,
  addGochiKidMenu,
  GET_SETTING_MENU_FREE_SUCCESS
} from '../../actions/GochiMenus';
import { sendLogin } from '../../auth/Auth';
import DetailTextButton from '../../components/atoms/DetailTextButton';
import GochiKidFreeDetailShop from '../organisms/GochiKidFreeDetailShop';

const styles = {
  lstMenu: {
    padding: 0
  },
  menuItem: {
    padding: 10
  },
  menuCard: {
    boxShadow: 'none',
    width: '100%',
    borderRadius: 0
  },
  menuCnt: {
    padding: 0,
    display: 'flex',
    marginBottom: 12
  },
  menuImg: {
    width: 80,
    boxShadow:
      '0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)'
  },
  menuInfo: {
    paddingLeft: 12,
    width: 'calc(100% - 80px)'
  },
  menuName: {
    fontSize: 16,
    color: '#000000',
    marginBottom: 5,
    whiteSpace: 'normal',
    fontWeight: 'bold',
    wordBreak: 'break-all'
  },
  menuPrice: {
    fontSize: 14
  },
  cardActions: {
    backgroundColor: '#F7F7F7',
    justifyContent: 'center',
    padding: '0px'
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  boxImg: {
    position: 'relative'
  },
  expiration: {
    color: 'red'
  },
  expirationEndDate: {
    fontSize: 10,
    marginRight: 5
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    null,
    dispatch => ({
      actions: bindActionCreators(
        {
          getSettingMenuFree,
          getGochiMenuDetail,
          removeGochiKidMenu,
          addGochiKidMenu
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('loading', 'updateLoading', false),
  withState('isSuccess', 'updateIsSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('groupName', 'setGroupName', ''),
  withState('shopId', 'setShopId', 0),
  withState('openProgress', 'updateOpenProgress', false),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('settingMenuDetail', 'setSettingMenuDetail', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    checkSession,
    actions,
    listMenus,
    loading,
    updateLoading,
    resultMessage,
    openProgress,
    updateOpenProgress,
    openDetailModal,
    updateOpenDetailModal,
    settingMenuDetail,
    setSettingMenuDetail
  }) => {
    const progressOkAction = () => {
      updateOpenProgress(false);
      updateLoading(false);
    };

    const handleOpenDetailModal = async menuId => {
      updateLoading(true);
      updateOpenProgress(true);
      const response = await actions
        .getSettingMenuFree(menuId)
        .then(data => checkSession(data));

      if (response.type === GET_SETTING_MENU_FREE_SUCCESS) {
        setSettingMenuDetail(response.payload);
        updateOpenDetailModal(true);
      } else {
        setSettingMenuDetail(null);
      }
      updateLoading(false);
      updateOpenProgress(false);
    };

    return (
      <div>
        {listMenus && (
          <List dense={false} className={classes.lstMenu}>
            {listMenus.map((gochiMenu, index) => {
              const key = `${gochiMenu.menuId}-${gochiMenu.shopId}-${
                gochiMenu.groupName
              }`;

              return (
                <ListItem
                  className={classes.menuItem}
                  key={key}
                  tabIndex={index + 1}
                >
                  <Card className={classes.menuCard}>
                    <CardContent className={classes.menuCnt}>
                      <Box className={classes.boxImg}>
                        <CardMedia
                          component="img"
                          alt={gochiMenu.menuName}
                          width="80"
                          image={gochiMenu.image || 'images/logo.png'}
                          title={gochiMenu.menuName}
                          className={[classes.menuImg]}
                        />
                      </Box>
                      <Box className={classes.menuInfo}>
                        <Typography
                          gutterBottom
                          variant="h5"
                          component="h5"
                          className={[classes.menuName]}
                        >
                          {gochiMenu.menuName}
                        </Typography>
                        <Typography
                          gutterBottom
                          component="p"
                          className={[classes.menuPrice]}
                        >
                          {'価格：'}
                          {gochiMenu.price}
                          {'円'}
                        </Typography>
                      </Box>
                    </CardContent>

                    <CardActions className={classes.cardActions}>
                      <DetailTextButton
                        onClickAction={() =>
                          handleOpenDetailModal(gochiMenu.menuId)
                        }
                      />
                    </CardActions>
                  </Card>
                </ListItem>
              );
            })}
          </List>
        )}

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />

        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
          className={classes.modalMobile}
        >
          <GochiKidFreeDetailShop
            updateOpenDetailModal={updateOpenDetailModal}
            settingMenuDetail={settingMenuDetail}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
